<script setup>
import moment from "moment";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Verifikasi Data
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container p-4">
              <!-- form di sini -->
              <form action="#" @submit.prevent="preventSubmit">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <table
                      class=""
                      style="width: 100%; font-family: 'Inter-Regular'"
                    >
                      <tbody>
                        <tr class="border rounded-top rounded-3">
                          <td
                            colspan="2"
                            class="fs-6 p-2 text-white font-medium"
                            style="background-color: #dd3737"
                          >
                            Informasi Umum
                          </td>
                        </tr>
                        <tr class="border">
                          <th
                            class="p-2"
                            style="width: 30%; background-color: #ffe5e5"
                          >
                            Keterangan
                          </th>
                          <th
                            class="p-2"
                            style="width: 70%; background-color: #ffe5e5"
                          >
                            Data
                          </th>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Nama Kontraktor</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.namaKontraktor != null"
                          >
                            {{ dc.namaKontraktor }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.namaKontraktor != null
                                ? kontraktor.namaKontraktor
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Logo</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.image != null && dc.image != ''"
                          >
                            <a
                              style="cursor: pointer"
                              @click="downloadFile(dc.image)"
                            >
                              File Logo
                            </a>
                          </td>
                          <td class="p-2 text-decoration-underline" v-else>
                            <a
                              style="cursor: pointer"
                              @click="downloadFile(kontraktor.image)"
                              >File Logo</a
                            >
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Nama PJO</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.namaPjo != null"
                          >
                            {{ dc.namaPjo }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.namaPjo != null
                                ? kontraktor.namaPjo
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Email PJO</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.picEmail != null"
                          >
                            {{ dc.picEmail }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.picEmail != null
                                ? kontraktor.picEmail
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">No. Handphone PJO</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.picPhone != null"
                          >
                            {{ dc.picPhone }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.picPhone != null
                                ? kontraktor.picPhone
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Kompetensi PJO</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.kompetensiPjo != null"
                          >
                            {{ dc.kompetensiPjo }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.kompetensiPjo != null
                                ? kontraktor.kompetensiPjo
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Tanggal Pengesahan</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.tglSuratPengesahan != null"
                          >
                            {{
                              moment(dc.tglSuratPengesahan).format(
                                "DD MMMM YYYY",
                              )
                            }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.tglSuratPengesahan != null
                                ? moment(kontraktor.tglSuratPengesahan).format(
                                    "DD MMMM YYYY",
                                  )
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Nomor Surat Pengesahan</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.noPengesahanPjo != null"
                          >
                            {{ dc.noPengesahanPjo }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.noPengesahanPjo != null
                                ? kontraktor.noPengesahanPjo
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">
                            File Dokumen Pengesahan
                          </td>
                          <td
                            class="p-2 text-danger fw-bold text-decoration-underline cursor-pointer"
                            @click="
                              dc.filePengesahan != null
                                ? viewFile(dc.filePengesahan)
                                : ''
                            "
                            v-if="dc.filePengesahan != null"
                          >
                            File Dokumen Pengesahan
                          </td>
                          <td
                            class="p-2 text-decoration-underline cursor-pointer"
                            @click="
                              kontraktor.filePengesahan != null
                                ? viewFile(kontraktor.filePengesahan)
                                : ''
                            "
                            v-else
                          >
                            {{
                              kontraktor.filePengesahan != null
                                ? "File Dokumen Pengesahan"
                                : "Belum ada dokumen Pengesahan"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Inisial</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.inisial != null"
                          >
                            {{ dc.inisial }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.inisial != null
                                ? kontraktor.inisial
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Klasifikasi</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.iujp != null"
                          >
                            {{ dc.iujp ? "Inti" : "Non Inti" }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.jenis != null ? kontraktor.jenis : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Kualifikasi Usaha</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.kualifikasiUsaha != null"
                          >
                            {{ kualifikasiUsaha(dc?.kualifikasiUsaha) }}
                          </td>
                          <td class="p-2" v-else>
                            {{ kualifikasiUsaha(kontraktor?.kualifikasiUsaha) }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Wilayah</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.provinsi != null"
                          >
                            {{ kontraktorLokasi(dc.provinsi) }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.wilayah != null
                                ? kontraktor.wilayah
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Alamat</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.alamat != null"
                          >
                            {{ dc.alamat }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.alamat != null
                                ? kontraktor.alamat
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Provinsi</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.provinsi != null"
                          >
                            {{ dc.provinsi }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.provinsi != null
                                ? kontraktor.provinsi
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Nomor NIB</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.noNib != null"
                          >
                            {{ dc.noNib }}
                          </td>
                          <td class="p-2" v-else>
                            {{ kontraktor.nib != null ? kontraktor.nib : "-" }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">File Dokumen NIB</td>
                          <td
                            class="p-2 text-danger fw-bold text-decoration-underline cursor-pointer"
                            @click="
                              dc.fileNib != null ? viewFile(dc.fileNib) : ''
                            "
                            v-if="dc.fileNib != null"
                          >
                            <font-awesome-icon
                              style="cursor: pointer"
                              icon="fa-solid fa-eye"
                            />
                            File Dokumen NIB
                          </td>
                          <td
                            class="p-2 text-decoration-underline cursor-pointer"
                            @click="
                              kontraktor.fileNib != null
                                ? viewFile(kontraktor.fileNib)
                                : ''
                            "
                            v-else
                          >
                            <font-awesome-icon
                              style="cursor: pointer"
                              icon="fa-solid fa-eye"
                            />
                            {{
                              kontraktor.fileNib != null
                                ? "File Dokumen NIB"
                                : "Belum ada dokumen NIB"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Nomor IUJP</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.noIujp != null"
                          >
                            {{ dc.noIujp }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.iujp != null ? kontraktor.iujp : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">Masa Berlaku IUJP</td>
                          <td
                            class="p-2 text-danger fw-bold"
                            v-if="dc.tglExpIujp != null"
                          >
                            {{ moment(dc.tglExpIujp).format("DD MMMM YYYY") }}
                          </td>
                          <td class="p-2" v-else>
                            {{
                              kontraktor.masaBerlaku != null
                                ? moment(kontraktor.masaBerlaku).format(
                                    "DD MMMM YYYY",
                                  )
                                : "-"
                            }}
                          </td>
                        </tr>
                        <tr class="border">
                          <td class="text-muted p-2">File Dokumen IUJP</td>
                          <td
                            class="p-2 text-danger fw-bold text-decoration-underline cursor-pointer"
                            @click="
                              dc.fileIujp != null ? viewFile(dc.fileIujp) : ''
                            "
                            v-if="dc.fileIujp != null"
                          >
                            <font-awesome-icon
                              style="cursor: pointer"
                              icon="fa-solid fa-eye"
                            />
                            File Dokumen IUJP
                          </td>
                          <td
                            class="p-2 text-decoration-underline cursor-pointer"
                            @click="
                              kontraktor.fileIujp != null
                                ? viewFile(kontraktor.fileIujp)
                                : ''
                            "
                            v-else
                          >
                            <font-awesome-icon
                              style="cursor: pointer"
                              icon="fa-solid fa-eye"
                            />
                            {{
                              kontraktor.fileIujp != null
                                ? "File Dokumen IUJP"
                                : "Belum ada dokumen IUJP"
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <table
                      class=""
                      style="width: 100%; font-family: 'Inter-Regular'"
                    >
                      <tbody>
                        <tr class="border rounded-top rounded-3">
                          <td
                            colspan="7"
                            class="fs-6 p-2 text-white font-medium"
                            style="background-color: #dd3737"
                          >
                            KBLI
                          </td>
                        </tr>
                        <tr class="border">
                          <th
                            class="p-2"
                            style="width: 6%; background-color: #ffe5e5"
                          >
                            Kode KBLI
                          </th>
                          <th
                            class="p-2"
                            style="width: 19%; background-color: #ffe5e5"
                          >
                            Judul
                          </th>
                          <th
                            class="p-2"
                            style="width: 14%; background-color: #ffe5e5"
                          >
                            Tingkat Resiko
                          </th>
                          <th
                            class="p-2"
                            style="width: 10%; background-color: #ffe5e5"
                          >
                            Sertifikat
                          </th>
                          <th
                            class="p-2"
                            style="width: 10%; background-color: #ffe5e5"
                          >
                            Izin
                          </th>
                          <th
                            class="p-2"
                            style="width: 8%; background-color: #ffe5e5"
                          >
                            Is Verified
                          </th>
                          <th
                            class="p-2"
                            style="width: 23%; background-color: #ffe5e5"
                          >
                            Catatan
                          </th>
                        </tr>
                        <template v-if="formValues.kblis.length > 0">
                          <tr
                            class="border"
                            v-for="(row, index) in formValues.kblis"
                            :key="kbliDomId(row, index)"
                          >
                            <td
                              class="p-2"
                              :class="{
                                'text-danger fw-bold': !row.isVerified,
                              }"
                            >
                              {{ row.kode }}
                            </td>
                            <td
                              class="p-2"
                              :class="{
                                'text-danger fw-bold': !row.isVerified,
                              }"
                            >
                              {{ row.deskripsi }}
                            </td>
                            <td
                              class="p-2"
                              :class="{
                                'text-danger fw-bold': !row.isVerified,
                              }"
                            >
                              {{
                                row.tingkatResiko == 1
                                  ? "Rendah"
                                  : row.tingkatResiko == 2
                                  ? "Menengah Rendah"
                                  : row.tingkatResiko == 3
                                  ? "Menengah Tinggi"
                                  : row.tingkatResiko == 4
                                  ? "Tinggi"
                                  : "-"
                              }}
                            </td>
                            <td
                              class="p-2"
                              :class="{
                                'text-danger fw-bold': !row.isVerified,
                              }"
                            >
                              <a
                                v-if="
                                  row.fileSertifikat != null &&
                                  row.tingkatResiko != 4
                                "
                                @click="viewFile(row.fileSertifikat)"
                                class="text-decoration-none cursor-pointer"
                                :class="{
                                  'text-danger fw-bold': !row.isVerified,
                                  'text-dark': row.isVerified,
                                }"
                              >
                                Terverifikasi
                                <font-awesome-icon
                                  size="xl"
                                  icon="fa-solid fa-file-arrow-down"
                                  class="text-danger"
                                />
                              </a>
                              <a v-else>-</a>
                            </td>
                            <td
                              class="p-2"
                              :class="{
                                'text-danger fw-bold': !row.isVerified,
                              }"
                            >
                              <a
                                v-if="
                                  row.fileIzin != null && row.tingkatResiko == 4
                                "
                                @click="viewFile(row.fileIzin)"
                                class="text-decoration-none cursor-pointer"
                                :class="{
                                  'text-danger fw-bold': !row.isVerified,
                                  'text-dark': row.isVerified,
                                }"
                              >
                                Terverifikasi
                                <font-awesome-icon
                                  size="xl"
                                  icon="fa-solid fa-file-arrow-down"
                                  class="text-danger"
                                />
                              </a>
                              <a v-else>-</a>
                            </td>
                            <td>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  v-model="row.isVerified"
                                  style="
                                    border-radius: 10px;
                                    border-color: black;
                                  "
                                />
                              </div>
                            </td>
                            <td class="py-2" style="padding-right: 0.5rem">
                              <textarea
                                class="form-control"
                                v-model="row.notes"
                                :id="`catatan-kbli-${kbliDomId(row, index)}`"
                              ></textarea>
                              <div
                                :id="`text-warning-kbli-${kbliDomId(
                                  row,
                                  index,
                                )}`"
                                class="invalid-feedback"
                              ></div>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr class="border">
                            <td colspan="7" class="text-center fst-italic p-2">
                              Belum ada data KBLI
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <table
                      class=""
                      style="width: 100%; font-family: 'Inter-Regular'"
                    >
                      <tbody>
                        <tr class="border rounded-top rounded-3">
                          <td
                            colspan="4"
                            class="fs-6 p-2 text-white font-medium"
                            style="background-color: #dd3737"
                          >
                            Bidang IUJP
                          </td>
                        </tr>
                        <tr class="border">
                          <th
                            class="p-2"
                            style="width: 20%; background-color: #ffe5e5"
                          >
                            Bidang
                          </th>
                          <th
                            class="p-2"
                            style="width: 46%; background-color: #ffe5e5"
                          >
                            Sub Bidang
                          </th>
                          <th
                            class="p-2"
                            style="width: 9%; background-color: #ffe5e5"
                          >
                            is Verified
                          </th>
                          <th
                            class="p-2"
                            style="width: 25%; background-color: #ffe5e5"
                          >
                            Catatan
                          </th>
                        </tr>
                        <template v-if="dcBidang.length > 0">
                          <tr
                            class="border"
                            v-for="(row, index) in dcBidang"
                            :key="index"
                          >
                            <td
                              class="p-2"
                              :class="{
                                'text-danger fw-bold': !row.is_verified,
                              }"
                            >
                              {{ row.NMBIDANG }}
                            </td>
                            <td
                              class="p-2"
                              :class="{
                                'text-danger fw-bold': !row.is_verified,
                              }"
                            >
                              {{ displaySubBidang(row.SUBBIDANG) }}
                            </td>
                            <td>
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  v-model="dcBidang[index].is_verified"
                                  style="
                                    border-radius: 10px;
                                    border-color: black;
                                  "
                                />
                              </div>
                            </td>
                            <td class="py-2" style="padding-right: 0.5rem">
                              <textarea
                                class="form-control"
                                v-model="dcBidang[index].notes"
                                :id="`catatan-bidang-${index}`"
                              ></textarea>
                              <div
                                :id="`text-warning-bidang-${index}`"
                                class="invalid-feedback"
                              ></div>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr class="border">
                            <td colspan="4" class="text-center fst-italic p-2">
                              Belum ada data Bidang IUJP
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                    <p
                      class="text-danger fst-italic"
                      v-if="dc.iujp || wajibIUJP"
                    >
                      <span class="fw-bold">*</span>Bidang wajib diisi ketika
                      klasifikasi Inti
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-end">
                    <button
                      @click="validasiIsVerified"
                      :disabled="!btnSetujui"
                      type="button"
                      class="btn btn-outline-danger w-25 me-2"
                    >
                      <!-- data-bs-toggle="modal" data-bs-target="#modalRejectChanges" -->
                      Tolak
                    </button>
                    <button
                      :disabled="btnSetujui"
                      type="button"
                      class="btn btn_cari w-25"
                      @click="approveChanges()"
                    >
                      Setujui
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
  <div
    class="modal fade"
    id="modalRejectChanges"
    tabindex="-1"
    aria-labelledby="modalRejectChangesLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Tolak Perubahan Data Kontraktor</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalRejectChanges"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold">Alasan</label>
              </div>
              <textarea
                class="form-control fs-8"
                id="exampleFormControlTextarea1"
                rows="7"
                v-model="reason"
                placeholder="Masukkan alasan mengapa perubahan data ditolak"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer border border-0 mt-1">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            :disabled="reason?.trim() == '' || reason == null"
            @click="rejectChanges()"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
table {
  table-layout: auto;
}
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}
.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue"
import GlobalDataMixin from "../../GlobalDataMixin";

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_DOWNLOAD,
  CMS_GET_CHANGES_KONTRAKTOR,
  CMS_SET_CHANGES_KONTRAKTOR,
  CMS_VIEW_DOCUMENT,
} from "../../constants.js";
import { kualifikasiUsaha, kontraktorLokasi } from "@/utilities/helpers";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const url = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_get_changes_kontraktor = API_BASE_URL + CMS_GET_CHANGES_KONTRAKTOR;
const url_set_changes_kontraktor = API_BASE_URL + CMS_SET_CHANGES_KONTRAKTOR;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;

export default {
  mixins: [GlobalDataMixin],
  name: "verifikasiDataKontraktorPage",
  components: { DefaultLayout },
  data() {
    return {
      dataChanges: {},
      dc: {},
      dcNewKBLIs: [],
      dcChangeKBLIs: [],
      dcBidang: [],
      isLoading: true,
      jumlahFile: 0,
      uploadedFile: 0,
      tingkatResiko: [
        { value: 1, label: "Rendah" },
        { value: 2, label: "Menengah Rendah" },
        { value: 3, label: "Menengah Tinggi" },
        { value: 4, label: "Tinggi" },
      ],
      kontraktor: {},
      bidang: [],
      kbli: [],
      bd: [],
      sbd: [],
      ref_bidangall: [],
      ref_bidang: [],
      ref_subbidang: [[]],
      temp_kblis: [
        { kode: "", deskripsi: "", tingkatResiko: "", tingkatResikoStr: "" },
      ],
      final_kblis: [],
      deleted_kblis: [],
      upload_kblis: [],
      added_kblis: [],
      wajibIUJP: false,
      formValues: {
        namaKontraktor: "",
        logo: "",
        inisial: "",
        klasifikasi: "",
        wilayah: "",
        alamat: "",
        provinsi: "",
        nomorNIB: "",
        nomorIUJP: "",
        namaPjo: "",
        nomorSuratPengesahan: "",
        tanggalPengesahan: "",
        masaBerlakuIUJP: "",
        kompetensiPjo: "",
        // kblis: [{ kode: "", deskripsi: "", tingkatResiko: "", tingkatResikoStr: "" }],
        kblis: [],
        bid: [],
        subbid: [],
        bidangs: [{ NMBIDANG: "", SUBBIDANG: "" }],
        fileDokumenPengesahan: "",
        fileDokumenIUJP: "",
        fileDokumenNIB: "",
      },
      validasiFile: {
        typeIujp: false,
        sizeIujp: false,
        typeNib: false,
        sizeNib: false,
        typeSuratPengesahan: false,
        sizeSuratPengesahan: false,
      },
      token:
        "Bearer eyJhbGciOiJIUzI1NiJ9.eyJwcm9maWxlX25hbWUiOiJrb250cmFrdG9yIiwic3ViIjoia29udHJha3RvciIsImtleSI6NjI3LCJpYXQiOjE3MDUwMjkyMDh9.37zBNhGh_eoujhqJLZeNts0GGmp8klwSH39AHDXaflY",
      kontraktorId: null,
      reason: null,
      notificationId: null,
      btnSetujui: true,
      checkKbliSetujui: false,
      checkBidangSetujui: false,
    };
  },
  mounted() {
    this.getChangesKontraktor(this.$route.params.id);
    this.kontraktorId = this.$route.params.id;
  },
  methods: {
    kualifikasiUsaha,
    kontraktorLokasi,
    preventSubmit() {
      console.log("prevent submit");
    },

    /** Suffix unik untuk id DOM catatan KBLI (baris baru dari changes punya id null). */
    kbliDomId(row, index) {
      if (row.id != null && row.id !== "") {
        return String(row.id);
      }
      return `n${index}`;
    },

    /** true jika nilai dari API changes ada (bukan undefined / null). */
    kbliChangeHas(value) {
      return value !== undefined && value !== null;
    },

    /**
     * Satu baris form KBLI: data detail kontraktor digabung dengan entri changes (id sama).
     * Changes memakai suratSertifikasi / suratIzin; detail memakai fileSertifikat / fileIzin.
     */
    buildFormKbliRowFromDetail(kb, change) {
      const has = this.kbliChangeHas;
      const ch = change || null;

      const kode = has(ch?.kode) ? ch.kode : kb.noKbli;
      const tingkatResiko = has(ch?.tingkatResiko)
        ? ch.tingkatResiko
        : kb.tingkatResiko;

      const fileSertifikat = has(ch?.suratSertifikasi)
        ? ch.suratSertifikasi
        : kb.fileSertifikat;
      const fileIzin = has(ch?.suratIzin) ? ch.suratIzin : kb.fileIzin;

      const izin = kb.noKbli == "9900" ? "Terbit" : "-";
      const nibKbli = this.kontraktor.nib != "" ? "Terbit" : "Tidak Terbit";

      const sertifikasiStandar =
        kb.fileSertifikat != null || has(ch?.suratSertifikasi)
          ? "Terverifikasi"
          : "-";

      return {
        id: kb.id,
        kode,
        deskripsi: has(ch?.deskripsi) ? ch.deskripsi : kb.deskripsi,
        izin,
        sertifikasiStandar,
        nibKbli,
        tingkatResiko,
        tingkatResikoStr: kb.tingkatResikoStr,
        show: true,
        deleted: false,
        updatedAt: kb.updatedAt,
        sizeSertifikasi: false,
        typeSertifikasi: false,
        sizeIzin: false,
        typeIzin: false,
        fileSertifikat,
        fileIzin,
        isCgKode: has(ch?.kode),
        isCgTingkatResiko: has(ch?.tingkatResiko),
        isCgSertifikasiStandar: has(ch?.suratSertifikasi),
        isCgSuratIzin: has(ch?.suratIzin),
        isVerified:
          ch?.is_verified != null && ch?.is_verified === false
            ? false
            : kb.isVerified,
        notes: kb.notes,
      };
    },

    /** Baris KBLI baru murni dari payload changes (id null). */
    buildFormKbliRowFromNewChange(nw) {
      const has = this.kbliChangeHas;
      const izin = nw.kode == "9900" ? "Terbit" : "-";
      const nibKbli = this.kontraktor.nib != "" ? "Terbit" : "Tidak Terbit";
      const sertifikasiStandar = has(nw.suratSertifikasi)
        ? "Terverifikasi"
        : "-";

      return {
        id: null,
        kode: nw.kode,
        deskripsi: nw.deskripsi,
        izin,
        sertifikasiStandar,
        nibKbli,
        tingkatResiko: nw.tingkatResiko,
        tingkatResikoStr: nw.tingkatResikoStr ?? null,
        show: true,
        deleted: false,
        updatedAt: null,
        sizeSertifikasi: false,
        typeSertifikasi: false,
        sizeIzin: false,
        typeIzin: false,
        fileSertifikat: nw.suratSertifikasi ?? null,
        fileIzin: nw.suratIzin ?? null,
        isCgKode: false,
        isCgTingkatResiko: false,
        isCgSertifikasiStandar: has(nw.suratSertifikasi),
        isCgSuratIzin: has(nw.suratIzin),
        isVerified: false,
        notes: null,
      };
    },
    setChangesKontraktor(kontraktorId, status, reason = null) {
      this.isLoading = true;
      const kblis = [];
      this.formValues.kblis.forEach((item) => {
        kblis.push({
          id: item.id,
          kode: item.kode,
          deskripsi: item.deskripsi,
          tingkatResiko: item.tingkatResiko,
          is_verified: item.isVerified,
          notes: item.notes,
        });
      });
      let bodyJson = {
        kontraktorId: kontraktorId,
        status: status,
        reason: reason,
        userId: this.userData.userId,
        kbli: kblis,
        bidangUsahaGems: JSON.stringify(this.dcBidangForPayload()),
      };

      if (status == "approved") {
        bodyJson = {
          kontraktorId: kontraktorId,
          status: status,
          userId: this.userData.userId,
          notificationId: this.notificationId,
          kbli: kblis,
          bidangUsahaGems: JSON.stringify(this.dcBidangForPayload()),
        };
      }

      axios
        .post(url_set_changes_kontraktor, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response setChangesKontraktor : ", response);

          this.isLoading = false;

          Swal.fire({
            title:
              status == "approved"
                ? "Setujui Perubahan Data Kontraktor"
                : "Tolak Perubahan Data Kontraktor",
            text:
              status == "approved"
                ? "Perubahan data kontraktor berhasil disetujui !"
                : "Perubahan data kontraktor berhasil ditolak !",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            this.$router
              .replace("/profileKontraktor/" + this.kontraktorId)
              .then(() => {
                this.$router.go();
              });
          });
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error setChangesKontraktor : ", error);
          alert("error setChangesKontraktor");
        });
    },
    approveChanges() {
      Swal.fire({
        title: "Konfirmasi Setuju Perubahan Data Kontraktor",
        text: "Apakah anda yakin untuk menyetujui perubahan data kontraktor ?",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.setChangesKontraktor(this.kontraktorId, "approved");
        }
      });
    },
    rejectChanges() {
      this.$refs.closeModalRejectChanges.click();
      this.setChangesKontraktor(this.kontraktorId, "rejected", this.reason);
    },

    getChangesKontraktor(kontraktorId) {
      let bodyJson = {
        kontraktorId: kontraktorId,
      };
      axios
        .post(url_get_changes_kontraktor, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.dataChanges = response.data;
          this.notificationId = this.dataChanges.notificationId;
          if (this.dataChanges.statusChanges != "created") {
            this.$router
              .replace("/profileKontraktor/" + this.kontraktorId)
              .then(() => {
                this.$router.go();
              });
          }
          this.dc = this.dataChanges.dataChanges;
          this.dcChangeKBLIs = this.dc.kblis.filter(
            (option) => option.id !== null,
          );
          this.dcNewKBLIs = this.dc.kblis.filter(
            (option) => option.id === null,
          );

          if (this.dc.bidangUsahaGems != null) {
            const bidang = this.parseBidangUsahaGemsFromDc(
              this.dc.bidangUsahaGems,
            );
            if (bidang.length > 0 && bidang[0].NMBIDANG != "") {
              const bidang_parse = [];
              bidang.forEach((item) => {
                bidang_parse.push({
                  NMBIDANG: item.NMBIDANG,
                  SUBBIDANG: item.SUBBIDANG,
                  is_verified: this.parseDcBidangItemVerified(
                    item.isVerified ?? item.is_verified,
                  ),
                  notes: this.parseDcBidangItemNotes(item.notes),
                });
              });
              this.dcBidang = bidang_parse;
            } else {
              this.dcBidang = [];
            }
          } else {
            this.dcBidang = [];
          }
          // console.log("this.dcBidang:", this.dcBidang);
          this.fetchData(this.$route.params.id);
        })
        .catch((error) => {
          console.log("error getChangesKontraktor : ", error);
        });
    },
    fetchData(id) {
      axios
        .get(url + id, { headers: { accept: "application/json" } })
        .then((response) => {
          this.kontraktor = response.data.detailKontraktor;
          // set value form edit
          this.formValues.namaKontraktor = this.kontraktor.namaKontraktor;
          this.formValues.inisial = this.kontraktor.inisial;
          this.formValues.klasifikasi = this.kontraktor.jenis;
          this.formValues.wilayah = this.kontraktor.wilayah;
          this.formValues.nomorNIB = this.kontraktor.nib;
          this.formValues.nomorIUJP = this.kontraktor.iujp;
          this.formValues.masaBerlakuIUJP = this.kontraktor.masaBerlaku;
          this.formValues.nomorSuratPengesahan =
            this.kontraktor.noPengesahanPjo;
          this.formValues.tanggalPengesahan =
            this.kontraktor.tglSuratPengesahan;
          this.formValues.namaPjo = this.kontraktor.namaPjo;
          this.formValues.kompetensiPjo = this.kontraktor.kompetensiPjo;

          if (this.formValues.klasifikasi.toLocaleLowerCase() == "inti") {
            this.wajibIUJP = true;
          }
          this.formValues.alamat = this.kontraktor.alamat;
          this.formValues.provinsi = this.kontraktor.provinsi;
          // end : set value form edit

          // loop bidang-subbidang
          var arr_bid = [];
          var arr_bidx = [];
          var abd = [];
          var asbd = [];
          var temp_key = "";
          var b = 0;
          var sb = 1;
          for (var key in this.kontraktor.bidang) {
            var subi = this.kontraktor.bidang[key];
            if (temp_key != key) {
              temp_key = key;
              b += 1;
              sb = 1;
            }
            abd.push(b + ". " + key);

            for (var xx in subi) {
              const parsed = this.parseBidangSubEntry(subi[xx]);
              arr_bid.push({
                bidang: b + ". " + key,
                subBidang: b + "." + sb + ". " + parsed.label,
              });
              arr_bidx.push({
                bidang: key,
                subBidang: parsed.label,
                is_verified: parsed.isVerified,
                notes: parsed.notes,
              });
              asbd.push(b + "." + sb + ". " + parsed.label);
              sb++;
            }
          }
          this.bidang = arr_bid;
          this.fillBidangFormRowsFromParsedIndex(arr_bidx);
          this.syncDcBidangWithDetailAndChangesFlags(arr_bidx);

          // end loop bidang-subbidang

          let kbli = response.data.dataKbli;
          const hasDetailKbli = kbli.length > 0;
          const hasNewKbli = (this.dcNewKBLIs || []).length > 0;
          if (hasDetailKbli || hasNewKbli) {
            const arr_kbli = [];
            const arr_kbli_o = [];

            for (const kb of kbli) {
              const change = this.dcChangeKBLIs.find((c) => c.id == kb.id);
              arr_kbli.push(this.buildFormKbliRowFromDetail(kb, change));
              arr_kbli_o.push({
                id: kb.id,
                kode: kb.noKbli,
                deskripsi: kb.deskripsi,
                izin: kb.noKbli == "9900" ? "Terbit" : "-",
                sertifikasiStandar: "-",
                nibKbli: this.kontraktor.nib != "" ? "Terbit" : "Tidak Terbit",
                tingkatResiko: kb.tingkatResiko,
                tingkatResikoStr: kb.tingkatResikoStr,
                updatedAt: kb.updatedAt,
                isVerified: kb.isVerified,
                notes: kb.notes,
              });
            }

            for (const nw of this.dcNewKBLIs || []) {
              arr_kbli.push(this.buildFormKbliRowFromNewChange(nw));
              arr_kbli_o.push({
                id: null,
                kode: nw.kode,
                deskripsi: nw.deskripsi,
                izin: nw.kode == "9900" ? "Terbit" : "-",
                sertifikasiStandar: "-",
                nibKbli: this.kontraktor.nib != "" ? "Terbit" : "Tidak Terbit",
                tingkatResiko: nw.tingkatResiko,
                tingkatResikoStr: nw.tingkatResikoStr ?? null,
                updatedAt: null,
                isVerified: false,
                notes: null,
              });
            }

            console.log({ arr_kbli });

            this.formValues.kblis = arr_kbli;
            this.temp_kblis = arr_kbli_o;
          }
          if (this.formValues.kblis?.length == 0) {
            this.btnSetujui = true;
          } else if (
            this.dc.iujp &&
            this.dcBidang.length === 0 &&
            this.formValues.kblis?.length > 0
          ) {
            this.btnSetujui = true;
          }

          this.bd = abd;
          this.sbd = asbd;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },
    /** Menampilkan teks bersih sub bidang di UI view tanpa merubah data asli/payload. */
    displaySubBidang(val) {
      if (!val) return "";
      let text = String(val).trim();
      while (/-(true|false)-(null|undefined|[a-zA-Z0-9\s]*)$/i.test(text)) {
        text = text
          .replace(/-(true|false)-(null|undefined|[a-zA-Z0-9\s]*)$/i, "")
          .trim();
      }
      return text;
    },

    /** Isi form bidang IUJP + opsi sub-bidang per baris dari hasil parse kontraktor.bidang. */
    /**
     * Parse satu entri sub-bidang dari API detail, format:
     *   "Nama Sub Bidang-{true|false}-{notes}"
     * Contoh: "Penyusunan ... UKL UPL)-true-" → verified true, notes kosong.
     * Jika tidak cocok pola (data lama), seluruh string = nama, verified default true.
     */
    parseBidangSubEntry(raw) {
      const s = String(raw ?? "");
      const m = s.match(/^([\s\S]*)-(true|false)-([\s\S]*)$/i);
      if (!m) {
        return {
          label: this.displaySubBidang(s),
          isVerified: false,
          notes: null,
        };
      }
      const tail = String(m[3] ?? "").trim();
      const notes =
        tail === "" ||
        tail.toLowerCase() === "null" ||
        tail.toLowerCase() === "undefined"
          ? null
          : tail;
      return {
        label: this.displaySubBidang(m[1]),
        isVerified: m[2].toLowerCase() === "true",
        notes,
      };
    },

    /** `bidangUsahaGems` dari API changes: string JSON atau sudah berupa array. */
    parseBidangUsahaGemsFromDc(raw) {
      if (raw == null || raw === "") {
        return [];
      }
      if (Array.isArray(raw)) {
        return raw;
      }
      if (typeof raw === "string") {
        try {
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [];
        }
      }
      return [];
    },

    /** Verified di payload kadang boolean, string "true", atau string JSON — bukan selalu JSON.parse. */
    parseDcBidangItemVerified(v) {
      if (v == null || v === "") {
        return false;
      }
      if (typeof v === "boolean") {
        return v;
      }
      if (typeof v === "number") {
        return v !== 0;
      }
      if (typeof v === "string") {
        const t = v.trim();
        if (t === "true" || t === "false") {
          return t === "true";
        }
        try {
          return JSON.parse(t);
        } catch {
          return false;
        }
      }
      return false;
    },

    /** Notes kadang objek JSON string, kadang teks bebas (mis. "ubah bidang …"). */
    parseDcBidangItemNotes(n) {
      if (n == null || n === "") {
        return null;
      }
      if (typeof n === "object") {
        return n;
      }
      if (typeof n === "string") {
        const trimmed = n.trim();
        if (
          trimmed === "" ||
          trimmed.toLowerCase() === "null" ||
          trimmed.toLowerCase() === "undefined"
        ) {
          return null;
        }
        try {
          const parsed = JSON.parse(trimmed);
          if (parsed == null) {
            return null;
          }
          if (typeof parsed === "string") {
            const pt = parsed.trim();
            if (
              pt === "" ||
              pt.toLowerCase() === "null" ||
              pt.toLowerCase() === "undefined"
            ) {
              return null;
            }
            return parsed;
          }
          return parsed;
        } catch {
          return n;
        }
      }
      return null;
    },

    fillBidangFormRowsFromParsedIndex(arr_bidx) {
      if (!arr_bidx.length) {
        return;
      }
      this.ref_subbidang = [];
      this.formValues.bidangs = arr_bidx.map((bd) => ({
        NMBIDANG: bd.bidang,
        SUBBIDANG: bd.subBidang,
      }));
      arr_bidx.forEach((bd, index) => {
        const parent = this.ref_bidangall.find(
          (opt) => opt.bidang === bd.bidang,
        );
        if (parent) {
          this.getSubBidang(parent.id, index);
        }
      });
    },

    /**
     * Tabel verifikasi Bidang IUJP memakai dcBidang.
     * - Jika tidak ada payload changes bidang: isi dari detail kontraktor (baca saja).
     * - Jika ada changes: tetap pakai baris changes, tandai baris yang pasangan bidang/sub
     */
    syncDcBidangWithDetailAndChangesFlags(arr_bidx) {
      if (this.dc.bidangUsahaGems == null) {
        const detailPairs = arr_bidx.map((bd) => ({
          NMBIDANG: bd.bidang,
          SUBBIDANG: bd.subBidang,
          is_verified: bd.is_verified,
          notes: this.parseDcBidangItemNotes(bd.notes ?? null),
        }));
        this.dcBidang = detailPairs.map((p) => ({
          NMBIDANG: p.NMBIDANG,
          SUBBIDANG: p.SUBBIDANG,
          is_verified: p.is_verified,
          notes: this.parseDcBidangItemNotes(p.notes),
        }));
        return;
      }

      if (!this.dcBidang?.length) {
        return;
      }

      this.dcBidang = this.dcBidang.map((row) => ({
        ...row,
        notes: this.parseDcBidangItemNotes(row.notes),
      }));
    },

    /** Hanya field yang dikirim API (tanpa flag UI). */
    dcBidangForPayload() {
      return (this.dcBidang || []).map(
        ({ NMBIDANG, SUBBIDANG, is_verified, notes }) => ({
          NMBIDANG,
          SUBBIDANG,
          is_verified,
          notes,
        }),
      );
    },
    getSubBidang(id_parent, index) {
      this.ref_subbidang[index] = [];
      let rsb = [];
      for (let i = 0; i < this.ref_bidangall.length; i++) {
        if (
          this.ref_bidangall[i].bidangParent == id_parent &&
          this.ref_bidangall[i].id != id_parent
        ) {
          rsb.push({
            id: this.ref_bidangall[i].id,
            bidang: this.ref_bidangall[i].bidang,
          });
        }
      }
      // console.log('getsubbid : ',index,' ',rsb);
      this.ref_subbidang[index] = rsb;
    },
    downloadFile(filename) {
      //   axios.get(url_download+filename)
      //   .then(()=>{

      //   });
      window.open(url_download + filename, "_blank");
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
    handlerButton(newVal, type) {
      if (type === "kbli") {
        this.checkKbliSetujui = newVal.every(
          (item) => item.isVerified !== null && item.isVerified !== false,
        );
      } else if (type === "bidang") {
        this.checkBidangSetujui = newVal.every(
          (item) => item.is_verified !== null && item.is_verified !== false,
        );
      }

      if (this.dcBidang.length > 0 && this.formValues.kblis.length > 0) {
        this.btnSetujui = !(this.checkKbliSetujui && this.checkBidangSetujui);
      } else if (
        this.dcBidang.length == 0 &&
        this.formValues.kblis.length > 0 &&
        !this.dc.iujp
      ) {
        this.btnSetujui = !this.checkKbliSetujui;
      }
    },
    validasiIsVerified() {
      let status = true;
      this.formValues.kblis?.forEach((item, index) => {
        const domId = this.kbliDomId(item, index);
        if (!item.isVerified && (!item.notes || item.notes?.trim() == "")) {
          document.querySelector(`#text-warning-kbli-${domId}`).textContent =
            "Catatan wajib diisi";
          document
            .querySelector(`#catatan-kbli-${domId}`)
            .classList.add("is-invalid");
          status = status && false;
        } else {
          document.querySelector(`#text-warning-kbli-${domId}`).textContent =
            "";
          document
            .querySelector(`#catatan-kbli-${domId}`)
            .classList.remove("is-invalid");
          status = status && true;
        }
      });

      this.dcBidang?.forEach((item, index) => {
        if (!item.is_verified && (!item.notes || item.notes?.trim() == "")) {
          document.querySelector(`#text-warning-bidang-${index}`).textContent =
            "Catatan wajib diisi";
          document
            .querySelector(`#catatan-bidang-${index}`)
            .classList.add("is-invalid");
          status = status && false;
        } else {
          document.querySelector(`#text-warning-bidang-${index}`).textContent =
            "";
          document
            .querySelector(`#catatan-bidang-${index}`)
            .classList.remove("is-invalid");
          status = status && true;
        }
      });
      if (status) {
        const newElement = document.createElement("button");
        newElement.setAttribute("data-bs-toggle", "modal");
        newElement.setAttribute("data-bs-target", "#modalRejectChanges");
        document.body.appendChild(newElement);
        newElement.click();
        setTimeout(() => {
          document.body.removeChild(newElement);
        }, 50);
      }
    },
  },
  watch: {
    "formValues.kblis": {
      handler(newVal) {
        this.handlerButton(newVal, "kbli");
      },
      deep: true,
    },
    dcBidang: {
      handler(newVal) {
        this.handlerButton(newVal, "bidang");
      },
      deep: true,
    },
  },
};
</script>
